import * as React from 'react';
import Box from '@mui/material/Box';

import { CssBaseline, Toolbar, useMediaQuery } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { grey } from '@mui/material/colors';
import * as amplitude from '@amplitude/analytics-browser';
import { ShowSystemNotification, SideMenu } from './molecules';
import { Conversation, Home, Library, Review, Settings } from './components';
import theme from './theme';

if (process.env.REACT_APP_AMPLITUDE_KEY) {
  amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY || '', {
    autocapture: true,
    fetchRemoteConfig: true,
  });
}

// Create a client

export default function App() {
  const isMD = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <SnackbarProvider maxSnack={5} style={{ maxWidth: isMD ? '90%' : '50%' }}>
      <React.Suspense fallback="Loading">
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />

          <SideMenu />

          <Box
            component="main"
            flexGrow={1}
            minHeight="100vh"
            bgcolor={grey[300]}
          >
            <Toolbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="conversation/:conversationId"
                element={<Conversation />}
              />
              <Route path="review/:reviewId" element={<Review />} />
              <Route path="settings" element={<Settings />} />
              <Route path="library" element={<Library />} />
            </Routes>
          </Box>
        </Box>
        <ShowSystemNotification />
      </React.Suspense>
    </SnackbarProvider>
  );
}
